import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { format, parseISO } from "date-fns";

export default function CustomersTable({ refreshKey }) {
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, [refreshKey]);

  return (
    <div className="paper-card overflow-hidden">
      <Table data-testid="customers-table">
        <TableHeader>
          <TableRow className="bg-[#e8dcc4]/40 hover:bg-[#e8dcc4]/40">
            <TableHead className="font-display text-[#1f2e1f]">Name</TableHead>
            <TableHead className="font-display text-[#1f2e1f]">Contact</TableHead>
            <TableHead className="font-display text-[#1f2e1f]">Bookings</TableHead>
            <TableHead className="font-display text-[#1f2e1f]">Lifetime Value</TableHead>
            <TableHead className="font-display text-[#1f2e1f]">Joined</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {customers.length === 0 && (
            <TableRow><TableCell colSpan={5} className="text-center text-[#8c8577] py-10">No customers yet</TableCell></TableRow>
          )}
          {customers.map((c) => (
            <TableRow key={c.id} data-testid={`customer-row-${c.id}`}>
              <TableCell className="font-medium text-[#1f2e1f]">{c.name}</TableCell>
              <TableCell>
                <div className="text-sm text-[#5a5245]">{c.email}</div>
                {c.phone && <div className="text-xs text-[#8c8577]">{c.phone}</div>}
              </TableCell>
              <TableCell className="text-[#5a5245]">{c.total_bookings}</TableCell>
              <TableCell className="font-display text-lg text-[#1f2e1f]">${c.total_spent.toLocaleString()}</TableCell>
              <TableCell className="text-xs text-[#8c8577]">{format(parseISO(c.created_at), "MMM d, yyyy")}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
